import React from 'react';
import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css';
import '@trp-beacon-ui-kit/foundation/fonts/fonts.css';
import '@trp-beacon-ui-kit/foundation/css/style.css';
import { Box } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconAccordion } from './BeaconRegister';

export default function ExpansionPanelConsent({
    children,
    id,
    singleOpen
}) {

    return (
        <>
            <Box className="demo-padded beacon-theme-modern-outlook">
                <PsBeaconAccordion
                    scale="jumbo"
                    single-open={singleOpen}
                    id={id}
                    motion-state='enabled'
                    style={{ backgroundColor: 'green !important' }}
                >
                    {children}
                </PsBeaconAccordion>
            </Box>
        </>
    );
}
